import React from 'react';
import i18n from 'i18next';
import axios from 'axios';

import { getMenuItems, ListEmpty } from '@/exceed';

import addNewAgendaItemModal from './addNewAgendaItemModal';
import getDeleteItemModal from './getDeleteItemModal';
import handleAdminVideoAxiosError from './handleAdminVideoAxiosError';
import editAgendaItemModal from './editAgendaItemModal';

export default ({
  adminSettings,
  currentUser,
  isEditingDisabled,
  params,
  queryClient,
  videoComposeList,
  videoVersionKey,
  isDeletingAgendaItem,
  setIsDeletingAgendaItem,
  versionId,
}) => {
  const videoId = versionId || params.id;
  const model = { live_video_id: Number(videoId) };

  const handleChange = () => {
    videoComposeList.refetch();
    queryClient.invalidateQueries(videoVersionKey);
  };

  const addMenuItems = getMenuItems([
    {
      icon: 'agenda',
      key: 'new-agenda-item',
      onClick: async () => {
        const { type } = await addNewAgendaItemModal(model, { adminSettings, currentUser });

        if (type === 'submit') {
          handleChange();
        }
      },
      isDisabled: isEditingDisabled,
    },
  ]);

  const listEmptyComponent = (
    <ListEmpty
      title={i18n.t('no-content-available')}
      body={i18n.t('no-agenda-items')}
      buttonText={i18n.t('add-content')}
      hasAddMenu
      addMenuItems={addMenuItems}
    />
  );

  return {
    currentTreeContent: videoComposeList.data,
    shouldShowLoading: videoComposeList.isPlaceholderData || isDeletingAgendaItem,
    shouldShowEmptyState: Object.keys(videoComposeList.data?.items).length === 1,
    listHeaderColumns: [i18n.t('start-date')],
    listHeaderTitle: i18n.t('agenda'),
    listHeaderAddMenuItems: addMenuItems,
    listEmptyComponent,
    isComposeListDisabled: isEditingDisabled,
    onKebabMenuItemClick: async ({ item, action }) => {
      switch (action) {
        case 'properties':
          {
            const { type } = await editAgendaItemModal({ item, ...model }, { adminSettings });

            if (type === 'submit') {
              handleChange();
            }
          }
          break;
        case 'delete':
          getDeleteItemModal({
            title: i18n.t('agenda-delete-title'),
            body: i18n.t('agenda-delete-body'),
            onDeleteButtonClick: async () => {
              try {
                setIsDeletingAgendaItem(true);
                await axios.delete(`/api/admin/live_videos/${videoId}/agenda_items/${item.id}`);
                handleChange();
              } catch (error) {
                handleAdminVideoAxiosError(error);
              }
              setIsDeletingAgendaItem(false);
            },
          });
          break;
        default:
          break;
      }
    },
  };
};
